import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Center,
  Checkbox,
  createStyles,
  Input,
  Loader,
  Select,
  Text,
} from "@mantine/core";
import { useMedplum } from "@medplum/react";
import { extractQuestionnare, getGeneratedQuestions } from "./Service";
import { IconGripVertical, IconPhone } from "@tabler/icons-react";
import { Summary } from "../AIRecipes/SummaryAi";

interface Details {
  open?: string;
  close?: any;
  showCheckboxes?: boolean;
  onSubmit?: (phoneNumber: string, linkIds: any, questionsText: any) => void;
  cancel?: any;
  onchange?: (value: string) => void; // Updated type
  checkBoxLabels?: any;
  patientId?: any;
  categoryName?: string;
  mobileNumber?: any;
  // onChatClick?: any;
  onChatClick?: (selectValue: string, filteredIds: any, questionsText: any, qtrId: any) => void;
}

export const ModalContent: React.FC<Details> = ({
  onSubmit,
  cancel,
  onchange,
  checkBoxLabels,
  mobileNumber,
  patientId,
  categoryName,
  onChatClick,
}) => {
  const useStyles = createStyles(() => ({
    mainBox: { padding: "16px" },
    box1: { display: "flex", flexDirection: "column", gap: "16px" },
    box2: {
      padding: "12px",
      gap: "8px",
      display: "flex",
      flexDirection: "column",
    },
    box3: {
      display: "flex",
      flexDirection: "column",
      border: "1px solid #EDEDED",
      borderRadius: "6px",
      gap: "12px",
      padding: "12px",
    },
    box4: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      justifyContent: "flex-end",
    },
    box5: { display: "flex", flexDirection: "row", gap: "8px" },
    text: { fontWeight: 600, fontSize: "14px", lineHeight: "21px" },
    boxSelect: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      width: "50%",
    },
    boxSelect1: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      gap: "6px",
    },
    card: {
      padding: '10px',
      borderRadius: '8px',
      backgroundColor: 'transparent',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    dragIcon: {
      marginRight: '10px',
      color: '#757575',
      cursor: 'grab',
      minWidth: 'fit-content',
      alignItems: 'center',
    },
    checkbox: {
      marginRight: '10px',
    },
    checkText: {
      flexGrow: 1,
    },
  }));

  const { classes } = useStyles();
  const medplum = useMedplum();
  const [questionsText, setQuestionsText] = useState<any>([]);
  const [qnrName, setQnrName] = useState("");
  const [isLoading, setisLoading] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(
    mobileNumber
  );
  const [selectValue, setSelectValue] = useState<any>("Voice Bot");
  const [draggingIndex, setDraggingIndex] = useState<number | null>(null);
  const [reorderedLinkIds, setReorderedLinkIds] = useState<string[]>([]);
  const [checkedArray, setCheckedArray] = useState<any>([]);
  const [filteredIds, setFilteredIds] = useState<any>([]);
  const [loadingText, setLoadingText] = useState<string>(`Analyzing Patient's <span style=\"color:#008000\">MedicationRequests</span> and <span style=\"color:blue\">Conditions</span>...`);

  useEffect(() => {
    getQuestions();
  }, []);

  useEffect(() => {
    const linqId = compareArrays(reorderedLinkIds);
    setFilteredIds(linqId);

  }, [checkedArray, reorderedLinkIds]);


  const handleSelectChange = (e: any) => {
    setSelectValue(e);
    if (onchange) {
      onchange(e); // Pass the selected value to the parent component
    }
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhoneNumber(e.target.value);
  };

  const getQuestions = () => {
    // extractQuestionnare(medplum, 20, 1, checkBoxLabels).then((res) => {
    //   setQnrName(res[0]?.name ?? "");
    //   // setQuestionsText(res[0]?.item);
    //   // const linkids = res[0]?.item || [];
    //   // const data = linkids.map((item) => item.linkId);
    //   // setReorderedLinkIds(data);

    //   // setCheckedArray(data); // Initialize checkedArray with all linkIds
    // });
    getGeneratedQuestions(medplum, patientId, categoryName ?? '').then(async(res) => {
      setQnrName(categoryName ?? '')
      setLoadingText(`Generating Personalized <span style=\"color:#008000\">Questionnaire</span> For the Patient...`)
      await new Promise((resolve)=>setTimeout(resolve, 5000))
      setisLoading(false);
      if (!res) return
      setQuestionsText(res)
      const linkIds = res.map((item: any) => item.linkId);
      setReorderedLinkIds(linkIds);
      setCheckedArray(linkIds);
    })
  };


  const handleDragStart = (index: number) => {
    setDraggingIndex(index);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault(); // Necessary to allow dropping
  };

  const handleDrop = (index: number) => {
    if (draggingIndex === null) return;

    const reorderedItems = [...questionsText];
    const [draggedItem] = reorderedItems.splice(draggingIndex, 1);
    reorderedItems.splice(index, 0, draggedItem);

    setQuestionsText(reorderedItems);

    const reorderedIds = reorderedItems.map((item) => item.linkId);
    setReorderedLinkIds(reorderedIds);

    setDraggingIndex(null);
  };

  const compareArrays = (otherArray: any[]) => {
    const result = [];
    for (const element of otherArray) {
      if (checkedArray.includes(element)) {
        result.push(element);
      }
    }
    return result;
  };

  return (
    <Box className={classes.mainBox}>
      {isLoading ? (
        <Box><Center mih="400px">
          <Loader variant="dots" />
        </Center>
          <Center sx={{ marginLeft: "-80px", maxWidth: "80%" }}><Summary 
            text={loadingText}
            title=""
            
          /></Center></Box>

      ) : (
        <Box className={classes.box1}>
          <Box className={classes.boxSelect1}>
            <Box className={classes.boxSelect}>
              <Text className={classes.text}>{qnrName}</Text>
              <Select
                data={["Feedback"]}
                placeholder={qnrName}
                radius="md"
                size="md"
                onChange={onchange}
                disabled={true}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <Select
                w={"100%"}
                data={["Voice Bot", "Chat Bot", "Create Form"]}
                defaultValue={"Voice Bot"}
                radius="md"
                size="md"
                onChange={handleSelectChange}
              />
            </Box>
          </Box>
          <Box className={classes.boxSelect}>
            <Text className={classes.text}>Phone Number</Text>
            <Input
              radius="md"
              size="md"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder="Enter Phone Number"
              rightSection={
                <IconPhone
                  size="1rem"
                  style={{ display: "block", opacity: 0.5 }}
                />
              }
            />
          </Box>
          <Box className={classes.box2}>
            <Text className={classes.text}>Questions</Text>
            {questionsText.length > 0 ? (
              <Box className={classes.box3}>
                {questionsText.map((item: any, index: any) => (
                  <div
                    key={item?.linkId}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={handleDragOver}
                    className={classes.card}
                    onDrop={() => handleDrop(index)}
                  >
                    <IconGripVertical className={classes.dragIcon} />
                    <Checkbox
                      checked={checkedArray.includes(item.linkId)} // Set initial checked state
                      // label={item?.text}
                      className={classes.checkbox}
                      size="sm"
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const itemId = item.linkId;
                        if (isChecked) {
                          setCheckedArray((prevArray: any) => [
                            ...prevArray,
                            itemId,
                          ]);
                        } else {
                          setCheckedArray((prevArray: any) =>
                            prevArray.filter((id: any) => id !== itemId)
                          );
                        }
                      }}
                    />
                    {item?.text}
                  </div>
                ))}
              </Box>
            ) : (
              <Box>No Data Available</Box>
            )}
          </Box>
          <Box className={classes.box4}>
            <Box className={classes.box5}>
              <Button
                onClick={cancel}
                variant="outline"
                sx={{ color: "#262930" }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (selectValue === "Voice Bot") {
                    onSubmit && onSubmit(phoneNumber!, filteredIds, questionsText);
                  } else if (onChatClick) {
                    onChatClick(selectValue, filteredIds, questionsText, checkBoxLabels);
                  }
                }}
                disabled={
                  !phoneNumber ||
                  phoneNumber.length === 0 ||
                  !checkBoxLabels ||
                  checkedArray.length === 0
                }
              >
                {selectValue === "Voice Bot"
                  ? "Start Call"
                  : selectValue === "Chat Bot"
                    ? "Start Chat"
                    : selectValue === "Create Form"
                      ? "Create Form"
                      : "Start Call"}{" "}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};
